import React from "react";
import logo from "../landingImgs/auctionlogo.png";
import { useMediaQuery } from "react-responsive";

const initialDataBuyer = [
  {
    id: 1,
    details: "Maximize returns on recyclable materials.",
  },
  {
    id: 2,
    details: "Peace of mind with verified traders.",
  },
];

const initialDataTrader = [
  {
    id: 1,
    details: "Acquire scrap materials at competitive prices.",
  },
  {
    id: 2,
    details: "Enhance trust with site inspections and feedback.",
  },
  {
    id: 3,
    details: "Risk-free bidding with guaranteed EMD.",
  },
  {
    id: 4,
    details: "Simplified transactions with the Cercle X Wallet.",
  },
  {
    id: 5,
    details: "Easy record-keeping with transaction reports.",
  },
];

const InfoSection = ({ title, data, fontSize }) => (

  <>
    <h5
      data-aos="fade-right"
      className={`mb-1 ${fontSize}`}
      
    >
      {title}
    </h5>
    {data.map((item) => (
      <div className="valign-wrapper gap-1" key={item.id} data-aos="fade-right">
        <img src={logo} alt="logo" />
        <p className={`font-20px NoOfline`} style={{ WebkitLineClamp: 1 }}>
          {item.details}
        </p>
      </div>
    ))}
  </>
);

function Seller() {
  const isDesktop = useMediaQuery({ query: "(max-width: 1600px)" });
  const isSmallLaptop = useMediaQuery({ query: "(max-width: 1200px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 650px)" });
  const FontSizeSeller = isSmallLaptop
    ? "font-16px"
    : isDesktop
    ? "font-20px"
    : "font-30px";

  return (
    <div className="full-width flex justify-center" style={{ order: isMobile&&2 }}>
     <div>
     <InfoSection
        title="Buyer"
        data={initialDataBuyer}
        fontSize={FontSizeSeller}
      />
      <InfoSection
        title="Trader"
        data={initialDataTrader}
        fontSize={FontSizeSeller}
      />
     </div>
    </div>
  );
}

export default Seller;
